/**
 * Shared contact type metadata — names, icons, and color tokens.
 * Single source of truth used by ContactCard, ContactsListPage, etc.
 */

import { Mail, Phone, MapPin, Globe, Star } from 'lucide-react';

export const CONTACT_TYPE_NAMES: Record<number, string> = {
  1: 'Email', 2: 'Cellphone', 3: 'Phone', 4: 'Pager', 5: 'Fax',
  6: 'Street Address', 7: 'Skype', 8: 'ICQ', 9: 'MSN', 10: 'AIM',
  11: 'Website', 12: 'Emergency Contact', 13: 'Work Address', 14: 'Work Email',
  15: 'Work Phone', 16: 'Work Phone 2', 17: 'Permanent Home Address',
  18: 'Postal Address', 19: 'Homestay Code',
};

export const TYPE_ICONS: Record<number, React.ReactNode> = {
  1: <Mail className="w-4 h-4" />, 2: <Phone className="w-4 h-4" />,
  3: <Phone className="w-4 h-4" />, 4: <Phone className="w-4 h-4" />,
  5: <Phone className="w-4 h-4" />, 6: <MapPin className="w-4 h-4" />,
  7: <Globe className="w-4 h-4" />, 8: <Globe className="w-4 h-4" />,
  9: <Globe className="w-4 h-4" />, 10: <Globe className="w-4 h-4" />,
  11: <Globe className="w-4 h-4" />, 12: <Star className="w-4 h-4" />,
  13: <MapPin className="w-4 h-4" />, 14: <Mail className="w-4 h-4" />,
  15: <Phone className="w-4 h-4" />, 16: <Phone className="w-4 h-4" />,
  17: <MapPin className="w-4 h-4" />, 18: <MapPin className="w-4 h-4" />,
  19: <MapPin className="w-4 h-4" />,
};

export const TYPE_COLORS: Record<number, string> = {
  1: 'bg-accent text-primary', 2: 'bg-blue-50 text-blue-600',
  3: 'bg-blue-50 text-blue-600', 4: 'bg-blue-50 text-blue-600',
  5: 'bg-slate-50 text-slate-600', 6: 'bg-emerald-50 text-emerald-600',
  7: 'bg-sky-50 text-sky-600', 8: 'bg-sky-50 text-sky-600',
  9: 'bg-sky-50 text-sky-600', 10: 'bg-sky-50 text-sky-600',
  11: 'bg-sky-50 text-sky-600', 12: 'bg-red-50 text-red-600',
  13: 'bg-emerald-50 text-emerald-600', 14: 'bg-purple-50 text-purple-600',
  15: 'bg-purple-50 text-purple-600', 16: 'bg-purple-50 text-purple-600',
  17: 'bg-emerald-50 text-emerald-600', 18: 'bg-amber-50 text-amber-600',
  19: 'bg-amber-50 text-amber-600',
};

/** Group contacts by typeId, preserving sort order within each group */
export function groupByType<T extends { typeId: number }>(contacts: T[]): Map<number, T[]> {
  const groups = new Map<number, T[]>();
  for (const c of contacts) {
    const list = groups.get(c.typeId);
    if (list) list.push(c);
    else groups.set(c.typeId, [c]);
  }
  return groups;
}
